<template>
	<div class="help_wrap" style="margin-top: 20px;">
		<div class="card">
			<div class="card-header" style="background: none; font-size: 20px; font-weight: bold;">帮助列表
			</div>
			<div class="card-body">
				
				<div class="classify_btn clearfix">
					<el-tag class="btn1" effect="plain" @click="classify_all" :class="{clickAll:showWhite!='-1'}">全部</el-tag>
					<el-tag class="btn1" effect="plain" type="info" v-for="(item,index) in help_classify" :id="item.cat_id" @click="classify_ck(item)" :class="{clickBgs:item.cat_title==showWhite}" >{{item.cat_title}}</el-tag>
				</div>
				
				<div class="">
					<el-table :data="tableData" v-loading="loading" style="width: 100%; cursor: pointer;">
						<el-table-column label="文章标题">
							<template slot-scope="scope">
								<a class="act_title" @click="help_id" :id="scope.row.article_id">{{ scope.row.title }}</a>
							</template>
						</el-table-column>
						<el-table-column label="发布日期">
							<template slot-scope="scope">
								<div>{{ scope.row.created_at }}</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		
		<!-- 分页 -->
		<div class="workbench_paging clearfix">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
			 :page-sizes="pageSizes" :page-size="pageSize" :total="help_num" layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</div>
		<!-- 分页 -->
	</div>
</template>

<script>
	import {
		Category,
		Article
	} from '../../common/api/http.js'
	export default {
		data() {
			return {
				tableData: [],//帮助列表
				help_classify:[],//帮助分类列表
				classify_id:'',//分类ID
				help_num: 10,
				currentPage:1,
				pageSize:10,
				pageSizes:[10,20,50,100],
				loading: false,
				showWhite:-1,
				showClose:false,
			}
		},
		mounted() {
			// 帮助分类
			let token = window.sessionStorage.getItem('token')
			Category({
				'api_token': token
			}).then(res => {
				// console.log(res)
				if(res.code==0){
					this.help_classify = res.data.cat_list
				}
			}).catch(err => {
				console.log(err)
			})
			// 帮助分类

			// 帮助列表
			this.help_list()
			// 帮助列表
		},
		methods: {
			classify_all(e){
				this.showWhite = -1
				this.classify_id = ''
				this.help_list()
			},
			// 帮助分类
			classify_ck(item){
				this.showWhite = item.cat_title
				this.classify_id = item.cat_id
				this.help_list()
			},
			handleSizeChange(val) {
				// console.log(`每页 ${val} 条`);
				this.pageSize = val
				this.help_list()
			},
			handleCurrentChange(val) {
				// console.log(`当前页: ${val}`);
				this.currentPage = val
				this.help_list()
			},
			help_id(e) {
				this.$router.push({
					path: '/settings/helpDatails',
					query: {
						id: e.srcElement.id
					}
				});
			},
			// 帮助列表
			help_list(){
				this.loading = true
				let token = window.sessionStorage.getItem('token')
				Article({
					'api_token': token,
					'page':this.currentPage,
					'page_size':this.pageSize,
					'cat_id':this.classify_id
				}).then(res => {
					// console.log(res)
					if (res.code == 0) {
						this.tableData = res.data.article_list
						this.help_num = parseInt(res.data.total)
					}
					this.loading = false
				}).catch(err => {
					// console.log(err)
					this.loading = false
					this.$message.error(err);
				})
			}
		}
	}
</script>

<style lang="less">
	.classify_btn {
		margin-bottom: 20px;
		.btn1 { cursor: pointer; margin: 0 10px 10px 0;}
	}
	.el-tag.clickBgs{
		background: white; border-color:#b3d8ff; color: #409eff;
	}
	.el-tag.clickAll{
		background: white; border-color:#d3d4d6; color: #909399;
	}
	.act_title {
		color: #007bff !important;

		&:hover {
			text-decoration: underline !important;
		}
	}

	.help_wrap {
		.el-table--enable-row-hover .el-table__body tr:hover>td {
			background-color: #fff !important;
		}
	}
</style>
